import type { GetMetricQueryParams } from '@gonfalon/openapi/operations/getMetric';
import { getMetricQuery } from '@gonfalon/rest-api/queries/metrics';
import { useSuspenseQuery } from '@tanstack/react-query';

export const useSuspenseMetric = (
  projectKey: string,
  metricKey: string,
  query?: GetMetricQueryParams,
  options?: { staleTime?: number },
) =>
  useSuspenseQuery({
    ...getMetricQuery({
      projectKey,
      metricKey,
      query,
    }),
    ...(options?.staleTime !== undefined && { staleTime: options.staleTime }),
  });
